import { createApp } from 'vue';

import ApiTokenModal from './ApiTokenModal.vue';
import { i18n } from '../../i18n';

const element = document.getElementById('api-token-modal');

if (element) {
  const jwtToken = element.getAttribute('data-jwt-token');
  const app = createApp(ApiTokenModal, {
    jwtToken,
  });
  app.use(i18n);
  app.mount(element);
}
